import React from 'react';
import styles from './Footer.module.scss';
import logo from '../../assets/images/CTV-Logo-color.svg';
import insta_icon from '../../assets/images/insta_icon.svg';
import fb_icon from '../../assets/images/fb_icon.svg';
import { APP_ROUTES, Routes } from "../../types/constants";
import { shareCombatTv } from '../../utils/share.utils';
import { toast } from 'react-toastify';
import { useSubscriptionStatus } from '../../providers/subscription-status.provider';

interface FooterProps {}

const Footer = (props: FooterProps) => {
  const year = new Date().getFullYear();
  const { hasActiveSubscription } = useSubscriptionStatus();
  const routes = hasActiveSubscription
    ? APP_ROUTES.filter((route) => route.route !== Routes.PRICING)
    : APP_ROUTES;
  const handleShare = async () => {
    const result = await shareCombatTv({
      title: 'Combat TV',
      text: 'Share Combat TV with your friends.'
    });

    if (result === 'copied') {
      toast.success('Link copied to clipboard.');
    }

    if (result === 'failed') {
      toast.error('Unable to share. Please copy the link.');
    }
  };

  return (
    <footer className={styles['footer']}>
      <div className={styles['container']}>
        <div className={styles['brand']}>
          <img src={logo} alt={'Combat TV'} className={styles['logo']} />
          <p className={styles['tagline']}>
            A modern home for combat sports stories, highlights, and live moments.
          </p>
          <div className={styles['socials']}>
            <button type="button" className={styles['socialButton']} aria-label="Visit Combat TV on Facebook">
              <img src={fb_icon} alt={'Facebook'} />
            </button>
            <button type="button" className={styles['socialButton']} aria-label="Visit Combat TV on Instagram">
              <img src={insta_icon} alt={'Instagram'} />
            </button>
            <button
              type="button"
              className={styles['socialButton']}
              aria-label="Share Combat TV"
              onClick={handleShare}
            >
              <span className={"material-symbols-outlined " + styles['shareIcon']} aria-hidden="true">share</span>
            </button>
          </div>
        </div>
        <div className={styles['links']}>
          <p className={styles['sectionTitle']}>Explore</p>
          <div className={styles['routeList']}>
            {routes.length > 0 &&
              routes.map(route => (
                <a key={route.name} href={route.route} className={styles['route']}>
                  {route.name}
                </a>
              ))}
          </div>
        </div>
        <div className={styles['meta']}>
          <p className={styles['sectionTitle']}>Support</p>
          <p className={styles['metaText']}>Questions or feedback?</p>
          <a className={styles['inlineLink']} href={Routes.CONTACT}>Contact us</a>
          <p className={styles['metaText']}>
            Built for fans who love the energy of the fight game.
          </p>
        </div>
      </div>
      <div className={styles['bottom']}>
        <p>© {year} Combat TV. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
